import PropTypes from 'prop-types'

import AppBarPortal from '../AppBar/AppBarPortal'

const TbxToolbar = ({ children, sx }) => {
    return <AppBarPortal sx={sx}>{children}</AppBarPortal>
}

TbxToolbar.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default TbxToolbar
